import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import user from './modules/user/user'
import enroll from './modules/enroll/enroll'
import info from './modules/info/info'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    user,
    enroll,
    info
  },
  // vuex 缓存插件，数据默认缓存在localstorage中，可配置缓存在cookie或者sessionstorage中
  //如果要存储数据本地需要自己通过paths添加
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: ['user', 'enroll']
    })
  ]
})